import React from "react";
import { cn } from "@repo/blacksmith-ui/cn";

export const STATUS_COLORS = {
  success: "var(--chart-1)",
  failure: "var(--chart-5)",
  cancelled: "var(--chart-grey)",
  skipped: "var(--chart-11)",
  default: "var(--chart-3)",
  unknown: "var(--chart-grey)",
  in_progress: "var(--chart-9)",
  queued: "var(--chart-3)",
};

export const DEFAULT_STATUS_OPTIONS: StatusOption[] = [
  {
    value: "in_progress",
    label: "In Progress",
    color: STATUS_COLORS.in_progress,
  },
  { value: "queued", label: "Queued", color: STATUS_COLORS.queued },
  { value: "success", label: "Success", color: STATUS_COLORS.success },
  { value: "failure", label: "Failed", color: STATUS_COLORS.failure },
  { value: "cancelled", label: "Cancelled", color: STATUS_COLORS.cancelled },
  { value: "skipped", label: "Skipped", color: STATUS_COLORS.skipped },
];

export const COMPLETED_STATUS_OPTIONS: StatusOption[] = [
  { value: "success", label: "Success", color: STATUS_COLORS.success },
  { value: "failure", label: "Failed", color: STATUS_COLORS.failure },
  { value: "cancelled", label: "Cancelled", color: STATUS_COLORS.cancelled },
  { value: "skipped", label: "Skipped", color: STATUS_COLORS.skipped },
];

export const GHA_STATUS_OPTIONS: StatusOption[] = [
  { value: "success", label: "Success", color: STATUS_COLORS.success },
  { value: "failure", label: "Failed", color: STATUS_COLORS.failure },
  { value: "cancelled", label: "Cancelled", color: STATUS_COLORS.cancelled },
];

export interface StatusOption {
  value: string;
  label: string;
  color?: string;
}

export interface StatusFilterProps {
  options?: StatusOption[];
  selectedValues: string[];
  onChange: (values: string[]) => void;
  provider?: "gha" | "docker";
}
